import React from 'react';
import T from '../../../../common/components/T';
const project = require('../../../../scripts/configs/project');
import css from './office-footer.module.scss';
import classNames from 'classnames';

const OfficeFooter = ({ transparentFooter }) => {
    const currentYear = new Date().getFullYear();

    return (
        <footer
            className={classNames(
                css.officeFooter,
                {
                    [css.officeFooterHidden]: transparentFooter && transparentFooter === 'hidden'
                },
                { [css.officeFooterWhite]: !transparentFooter }
            )}
        >
            <p className={css.copyright}>
                <T
                    textName='copyright-gt'
                    vars={{
                        year: currentYear,
                        company: project?.company
                    }}
                    defaultStr='© ${year} ${company}. All rights reserved'
                    page='all'
                />
            </p>
            {/* <div className={css.dev}>
                <p className={css.devText}>
                    <T textName='devText' defaultStr='Разработка' page='all' />
                    {' - '}
                </p>
                <A className={classNames(css.devLink, css.cursorPointer)} href={project?.developer?.link}>
                    {project?.developer?.text}
                </A>
            </div> */}
        </footer>
    );
};

export default OfficeFooter;
